export const blockIconsBusinessandpaymentsShoppingCartNew = (
	<span className='material-symbols-outlined'>shopping_cart</span>
);
